import { motion } from 'framer-motion';
import React from 'react';

import { GOLD } from '../constants';

export function GoldenSnitches() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      {[
        { x: '2%', y: '40%', dirX: 1 },
        { x: '92%', y: '60%', dirX: -1 },
      ].map((s, i) => (
        <motion.svg key={`snitch-${i}`} className='absolute' width='48' height='26' viewBox='0 0 72 36' fill='none' style={{ left: s.x, top: s.y, filter: `drop-shadow(0 0 10px ${GOLD}) drop-shadow(0 0 20px ${GOLD}90)` }} animate={{ opacity: [0.3, 0.7, 0.5, 0.7, 0.3], x: [0, s.dirX * 80, s.dirX * -40, s.dirX * 100, s.dirX * 50, 0], y: [0, -25, 15, -20, 10, 0] }} transition={{ duration: 2 + i * 0.5, delay: i * 0.8, repeat: Infinity, ease: 'easeInOut' as const }}>
          <circle cx='36' cy='18' r='7' fill={GOLD} opacity='0.95' />
          <circle cx='36' cy='18' r='10' stroke={GOLD} strokeWidth='0.8' fill='none' opacity='0.5' />
          <circle cx='34' cy='16' r='2.5' fill='#fff' opacity='0.6' />
          <motion.g animate={{ rotate: [-20, 20, -20] }} transition={{ duration: 0.1, repeat: Infinity, ease: 'easeInOut' as const }} style={{ transformOrigin: '28px 18px' } as React.CSSProperties}>
            <path d='M28 18 Q18 5, 3 9 Q12 15, 28 18' stroke={GOLD} strokeWidth='1' fill={`${GOLD}30`} />
          </motion.g>
          <motion.g animate={{ rotate: [20, -20, 20] }} transition={{ duration: 0.1, repeat: Infinity, ease: 'easeInOut' as const }} style={{ transformOrigin: '44px 18px' } as React.CSSProperties}>
            <path d='M44 18 Q54 5, 69 9 Q60 15, 44 18' stroke={GOLD} strokeWidth='1' fill={`${GOLD}30`} />
          </motion.g>
        </motion.svg>
      ))}
    </div>
  );
}
